module.exports = __webpack_public_path__ + "img/six_.376f287f.png";